import { useDispatch } from 'react-redux';
import type { AnyAction, Dispatch, ThunkDispatch } from '@reduxjs/toolkit';
import type { RootState } from './types';

// `ThunkDispatch` covers thunks and plain actions; `Dispatch` is augmented by
// `@types/redux-api-middleware` to also accept RSAA actions.
export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction> & Dispatch<AnyAction>;

export const useAppDispatch: () => AppDispatch = useDispatch;
